(ns practitest.frontend.dashboards-settings.main
  (:require [re-frame.core :as re-frame]
            [practitest.frontend.dashboards-settings.events :as events]
            [practitest.frontend.dashboards-settings.views :as views]))

(defn index-view []
  [views/page])

(defn page-controller []
  {:start (fn [_] (re-frame/dispatch [::events/fetch]))
   :stop  (fn [_] (re-frame/dispatch [::events/reset]))})
